import { SpotImage } from "@/common/model/spotimages/SpotImage";

interface CoverImagePreviewProps {
  coverImage: SpotImage | null;
  coverStaticUrl: string | null;
  spotName: string;
}

const CoverImagePreview: React.FC<CoverImagePreviewProps> = ({
  coverImage,
  coverStaticUrl,
  spotName,
}) => {
  const imageUrl = coverImage?.publicUrl || coverStaticUrl;

  if (!imageUrl) {
    return (
      <div className="bg-gray-100 rounded-lg p-8 text-center">
        <p className="text-gray-500">No cover image set</p>
      </div>
    );
  }

  return (
    <div className="relative rounded-lg overflow-hidden shadow-lg max-w-2xl">
      <div className="aspect-video">
        <img
          src={imageUrl}
          alt={`Cover for ${spotName}`}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
        <div className="flex items-center gap-2">
          <span className="px-2 py-1 bg-blue-500 text-white text-xs font-semibold rounded">
            Current Cover
          </span>
          {coverImage?.score !== null && coverImage?.score !== undefined && (
            <span className="px-2 py-1 bg-black/50 text-white text-xs rounded">
              Score: {(coverImage.score * 100).toFixed(1)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoverImagePreview;
